import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import environmentData from './environments/environment.json';

if (environmentData.production) {
  enableProdMode();
}

const baseElement = document.querySelector('base');
if (baseElement) {
  const origin =
    window.location.origin ||
    `${window.location.protocol}//${window.location.host}`;
  baseElement.setAttribute('href', `${origin}/`);
}

const bootstrap = () =>
  platformBrowserDynamic().bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  });

// if (environment.hmr) {
//   // start HMR
//     if (module['hot']) {
//     hmrBootstrap(module, bootstrap);
//   } else {
//     console.error('HMR is not enabled for webpack-dev-server!');
//     console.log('Are you using the --hmr flag for ng serve?');
//   }
// } else {
//   // normal app loading
bootstrap().catch((err) => console.log(err));
// }
